import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export type IGetCashRegistersExcelRepoResponse = IRepoResponse<200, Blob> | IRepoResponse<400 | 500, string>;

export type IGetCashRegistersExcelRepo = IRepo<[{ query: Record<string, any> }], IGetCashRegistersExcelRepoResponse>;

export const GetCashRegistersExcelRepoType = Symbol.for('GetCashRegistersExcelRepo');

@bind(GetCashRegistersExcelRepoType)
export class GetCashRegistersExcelRepo implements IGetCashRegistersExcelRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute({ query }) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/cashboxes/export', query) });

      if (result.status === 200) {
        const blob = await result.blob();

        if (blob) {
          return {
            status: 200 as 200,
            response: blob,
          };
        } else {
          return {
            status: 400 as 400,
            response: 'Məlumatlar əldə edilə bilmədi',
          };
        }
      } else if (result.status === 400 || result.status === 422) {
        return {
          status: 400 as 400,
          response: Object.values(result.data.errors).flat().join('. '),
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
